import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CompanyDataAgeChart from './CompanyDataAgeChart';
import CompanyAverageDataAgeChart from './CompanyAverageDataAgeChart';
import CompanyDataAgeHistogram from './CompanyDataAgeHistogram';
import MetricByBannerChart from './MetricByBannerChart';
import { Box, IconButton, CircularProgress } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import axios from 'axios';
import envConfig from '../../../bin/env.config';
import { findMetricOption, getMetricChartParams, isPercentMetric } from './oodMetricConfig';

export default function ChartsOutOfDateDialog({
  open,
  onClose,
  user_type_id,
  selectedCity,
  selectedBanners,
  token,
  selectedMetric,
  datePeriod,
}) {
  const [chartData, setChartData] = useState([]);
  const [metricChartData, setMetricChartData] = useState([]);
  const [loading, setLoading] = useState(false);

  const activeMetric = findMetricOption(selectedMetric);
  const chartParams = getMetricChartParams(selectedMetric);

  useEffect(() => {
    if (!open) return;

    const fetchChartData = async () => {
      try {
        setLoading(true);
        const [storeRes, metricRes] = await Promise.all([
          axios.post(
            `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/data-freshness-reporting/out-of-date-store-summary`,
            {
              user_type_id,
              city: selectedCity,
              banners: selectedBanners,
              date_period: datePeriod,
            },
            { headers: { Authorization: token } }
          ),
          axios.post(
            `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/data-freshness-reporting/out-of-date-metric-chart-by-banner`,
            {
              user_type_id,
              city: selectedCity,
              banners: selectedBanners,
              date_period: datePeriod,
              metric_field: chartParams.metric_field,
              is_percent: chartParams.is_percent,
            },
            { headers: { Authorization: token } }
          ),
        ]);
        setChartData(storeRes.data.data || []);
        setMetricChartData(metricRes.data.data || []);
      } catch (error) {
        console.error('Error fetching chart data:', error);
        setChartData([]);
        setMetricChartData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, [open, user_type_id, selectedCity, selectedBanners, token, datePeriod, selectedMetric]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span>Summary Charts</span>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Selected metric by banner
              </Typography>
              <MetricByBannerChart
                chartData={metricChartData}
                metricLabel={activeMetric.label}
                isPercent={isPercentMetric(selectedMetric)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Product Data Age Distribution
              </Typography>
              <CompanyDataAgeChart outOfDateProducts={chartData} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Average Data Age by Category
              </Typography>
              <CompanyAverageDataAgeChart outOfDateProducts={chartData} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Data Age Histogram
              </Typography>
              <CompanyDataAgeHistogram outOfDateProducts={chartData} />
            </Grid>
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
}
